import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useFetchUserAbout } from 'utils/hooks';

function SpateChurnZero() {
    const { user } = useAuth0();
    const { data } = useFetchUserAbout({ enabled: !!user });
    const email = user?.email;
    const clientId = data?.client_info?.client_id;
    const appKey = window?.spate_env?.CHURNZERO_APP_KEY;
    const churnZero = window?.ChurnZero;

    useEffect(() => {
        if (!(appKey && churnZero)) return;
        churnZero.push(['setAppKey', appKey]);
    }, [appKey, churnZero]);

    useEffect(() => {
        if (!(churnZero && appKey && email && clientId)) return;
        churnZero.push(['setContact', clientId, email]);
    }, [churnZero, appKey, email, clientId]);

    useEffect(() => {
        if (!(churnZero && appKey && email && clientId)) return;
        if (window.__spate_pendingChurnZeroLogin) {
            churnZero.push(['trackEvent', 'Login']);
            window.__spate_pendingChurnZeroLogin = false;
        }
    }, [churnZero, appKey, email, clientId]);

    return null;
}

export default SpateChurnZero;
